import { AccoListerAcco } from '@/scopes/common/domain/acco-lister/types'
import { mapParticipants } from '@/scopes/common/domain/functions/mapParticipants'
import { AccoListerApiResponse } from '@/scopes/common/infrastructure/acco-lister/types'

export interface AccoListerResponseMapper {
  map: (apiResponse: AccoListerApiResponse) => AccoListerAcco[]
}

export const createAccoListerResponseMapper: () => AccoListerResponseMapper = () => {
  function map({ results: data }: AccoListerApiResponse): AccoListerAcco[] {
    if (!data) {
      return []
    }

    return data.filter(item => item.image).map<AccoListerAcco>((item) => {
      const mappedItem: AccoListerAcco = {
        id: item.accommodationId,
        name: item.name,
        imageUrl: item.image!,
        rating: item.rating,
        city: item.cityName,
        region: item.regionName,
        country: item.countryName,
        url: item.url,
        price: {
          averagePrice: item.price.averagePrice,
          includedServices: { ...item.price.includedServices },
          staticText: item.price.staticText,
          departureDate: item.price.acmInformation?.departureDateRaw,
          durationInDays: item.price.acmInformation?.durationRaw,
          mealplan: { code: item.price.acmInformation?.mealplanCode ?? '', name: item.mealplan ?? '' },
          transportType: item.price.acmInformation?.transportType,
          participants: mapParticipants(item.price.acmInformation?.birthdates ?? []),
          showAcmInformation: !!item.price.acmInformation,
        },
        userRating: item.userRating,
        usps: item.usps,
      }

      if (item.price.priceDiscounts) {
        mappedItem.price.discount = {
          percentage: item.price.priceDiscounts.discountPercentage,
          originalPrice: item.price.priceDiscounts.originalPrice,
        }
      }

      return mappedItem
    })
  }

  return { map }
}
